
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth, apikey } from '../../constants/api';
import {
    TRANSACTION_FETCH,
    TRANSACTION_SUMMARY_FETCH,
    TRANSACTION_MONTHLY_FETCH,
    TRANSACTION_MACHINETYPE_FETCH,
    TRANSACTION_CONFIRMATION_FETCH,
    TRANSACTION_BY_SERVICE_FETCH
} from '../actions';
import moment from 'moment';

import {
    transactionSuccess,
    transactionFail,
    transactionMonthlySuccess,
    transactionMonthlyFail,
    transactionSummarySuccess,
    transactionSummaryFail,
    transactionMachineTypeFetchSuccess,
    transactionMachineTypeFetchFail,
    transactionComfirmationFetchSuccess,
    transactionComfirmationFetchFail,
    transactionByServiceFetchSuccess,
    transactionByServiceFetchFail
} from './actions';
import { sessionDenied } from '../actions';

import { sortOrder} from '../../helpers/Utils';

const transactionFetchAsync = async (user, queryString) =>
    await API.get('/transaction?'+queryString,
    {
      headers : {
        'Content-Type': 'application/json',
        'userid': user.user_id,
        'usertoken': user.user_token,
        'apikey': apikey
      }
    })
        .then(payments => payments)
        .catch(error => error);

function* transactionFetch({ payload }) {
    const { user, queryString } = payload.transaction
    const query = Object.keys(queryString).map(key => key + '=' + payload.transaction.queryString[key]).join('&');

    const { history } = payload;
    try {
        const transactionFetch = yield call(transactionFetchAsync, user, query);
        if (transactionFetch.data.StatusCode === "0000") {
            const total = transactionFetch.data.ResultValues.map(item => item.tran_amount).reduce((prev, next) => prev + next)
            let transactionList = {}
            transactionList.transaction = transactionFetch.data.ResultValues
            transactionList.total = total
            yield put(transactionSuccess(transactionList));

        } else if (transactionFetch.data.StatusCode === "0005"){
            localStorage.removeItem('user_id');
            history.push('/user')

        } else {
            yield put(transactionFail(transactionFetch.data.Message));
        }
    } catch (error) {
        yield put(transactionFail(error));
    }
}

function* transactionSummaryFetch({ payload }) {
    const { userid, usertoken, startdate, enddate } = payload.transactionSummary
    const { history } = payload;
    let userData = {}
    let query = {}
    userData.user_id = userid
    userData.user_token = usertoken
    query.startdate = startdate
    query.enddate = enddate

    const queryString = Object.keys(query).map(key => key + '=' + query[key]).join('&');

    try {
        const transactionSummaryFetch = yield call(transactionFetchAsync, userData, queryString);

        if (transactionSummaryFetch.data.StatusCode === "0000") {
          let data = transactionSummaryFetch.data.ResultValues
          let total = {}

          let totalAmount = data.map(item => item.tran_amount).reduce((prev, next) => prev + next)
          let totalCount = data.length
          let avg = totalAmount/totalCount
          let totalAvg = avg.toFixed(1)

          total.totalAmount = totalAmount
          total.totalCount = totalCount
          total.totalAvg = totalAvg

          yield put(transactionSummarySuccess(total));
        } else if (transactionSummaryFetch.data.StatusCode === "0005"){
            localStorage.removeItem('user_id');
            history.push('/user')
            yield put(sessionDenied(transactionSummaryFetch.data.Message));

        } else {
            yield put(transactionSummaryFail(transactionSummaryFetch.data.Message));
        }
    } catch (error) {
        yield put(transactionSummaryFail(error));
    }
}

// function* transactionSummaryFetch({ payload }) {
//     const { user, queryString } = payload.transactionSummary
//     const query = Object.keys(queryString).map(key => key + '=' + payload.transactionSummary.queryString[key]).join('&');
//
//     try {
//         const transactionSummaryFetch = yield call(transactionFetchAsync, user, query);
//         // console.log('transactionSummaryFetch : ',transactionSummaryFetch)
//         if (transactionSummaryFetch.data.StatusCode === "0000") {
//           // console.log('------------')
//             let transactionSummary= {};
//             let totalAll = transactionSummaryFetch.data.ResultValues.map(item => item.tran_amount).reduce((prev, next) => prev + next)
//             transactionSummary.tran_totalamount = totalAll
//             // console.log("transactionSummary : ",transactionSummary)
//             yield put(transactionSummarySuccess(transactionSummary));
//         } else {
//             yield put(transactionSummaryFail(transactionSummaryFetch.data.Message));
//         }
//     } catch (error) {
//         yield put(transactionSummaryFail(error));
//     }
// }

//-----------------------------------------------------------------------------
function* transactionMonthlyFetch({ payload }) {
    const { userid, usertoken, startdate, enddate, chartLabel, chartType } = payload.monthly
    let userData = {}
    let query = {}
    userData.user_id = userid
    userData.user_token = usertoken
    query.startdate = startdate
    query.enddate = enddate

    const queryString = Object.keys(query).map(key => key + '=' + query[key]).join('&');
    let type = chartType

    try {
        const transactionFetch = yield call(transactionFetchAsync, userData, queryString);
        if (transactionFetch.data.StatusCode === "0000") {
          const transactionFetchs = transactionFetch.data.ResultValues
          if (type === 'hour') {
            let object = {}, transactions = [];
            let period = [], amount = [];

            for (let i=0; i < transactionFetchs.length; i++) {
                let date = transactionFetchs[i].tran_issuedate;
                let localDateString = date.substring(11, 13)
                if (object[localDateString]) {
                    object[localDateString].tran_amount += transactionFetchs[i].tran_amount;
                } else {
                    transactionFetchs[i].date = localDateString;
                    delete transactionFetchs[i].tran_issuedate;
                    object[localDateString] = transactionFetchs[i];
                }
            }

            for (var prop in object) {
              transactions.push(object[prop]);
            }

            transactions.sort(sortOrder('date'));
            function compare(arr1,arr2) {
              let finalArray = [];
              arr1.forEach((e1)=>arr2.forEach((e2)=>
                {if(e1 === e2.date){
                  finalArray.push({
                   key: e1,
                   val: e2.tran_amount
                  })

                } else {
                 finalArray.push({
                   key: e1,
                   val: 0
                  })
                }
               }
              ))
              return finalArray;
            }

             let objArr = compare(chartLabel,transactions)
             const output = objArr.reduce((accumulator, cur) => {
              let date = cur.key;
              let found = accumulator.find(elem => elem.key === date)
              if (found) found.val += cur.val;
              else accumulator.push(cur);
              return accumulator;
            }, []);

              for (let i=0; i<output.length; i++) {
                period.push(output[i].key+':00')
                amount.push(output[i].val.toFixed(2))
              }

              let transactionChartMonthly = {}
              transactionChartMonthly.period = period
              transactionChartMonthly.amount = amount
              // console.log("transactionChartMonthly : ",transactionChartMonthly)
            yield put(transactionMonthlySuccess(transactionChartMonthly));
            //---------------------------------------------------------
          } else if (type === 'day') {
            let object = {}, transactions = [];
            let period = [], amount = [];

            for (let i=0; i < transactionFetchs.length; i++) {
                let date = transactionFetchs[i].tran_issuedate;
                let localDateString = date.substring(0, 10)
                if (object[localDateString]) {
                    object[localDateString].tran_amount += transactionFetchs[i].tran_amount;
                } else {
                    transactionFetchs[i].date = localDateString;
                    delete transactionFetchs[i].tran_issuedate;
                    object[localDateString] = transactionFetchs[i];
                }
            }

            for (var prop2 in object) {
              transactions.push(object[prop2]);
            }
            transactions.sort(sortOrder('date'));

            function compare(arr1,arr2) {
              let finalArray = [];
              arr1.forEach((e1)=>arr2.forEach((e2)=>
                {if(e1 === e2.date){
                  finalArray.push({
                   key: e1,
                   val: e2.tran_amount
                  })

                } else {
                 finalArray.push({
                   key: e1,
                   val: 0
                  })
                }
               }
              ))
              return finalArray;
            }

             let objArr = compare(chartLabel,transactions)

             const output = objArr.reduce((accumulator, cur) => {
              let date = cur.key;
              let found = accumulator.find(elem => elem.key === date)
              if (found) found.val += cur.val;
              else accumulator.push(cur);
              return accumulator;
            }, []);
              for (let i=0; i<output.length; i++) {
                period.push(moment(output[i].key).format('MMM DD, ddd'))
                amount.push(output[i].val.toFixed(2))
              }

              let transactionChartMonthly = {}
              transactionChartMonthly.period = period
              transactionChartMonthly.amount = amount

            yield put(transactionMonthlySuccess(transactionChartMonthly));

          } else if (type === 'month') {
            let object = {}, transactions = [];
            let period = [], amount = [];

            for (let i=0; i < transactionFetchs.length; i++) {
                let date = transactionFetchs[i].tran_issuedate;
                let localDateString = date.substring(0, 7)
                if (object[localDateString]) {
                    object[localDateString].tran_amount += transactionFetchs[i].tran_amount;
                } else {
                    transactionFetchs[i].date = localDateString;
                    delete transactionFetchs[i].tran_issuedate;
                    object[localDateString] = transactionFetchs[i];
                }
            }

            for (var prop3 in object) {
              transactions.push(object[prop3]);
            }
            transactions.sort(sortOrder('date'));

            function compare(arr1,arr2) {
              let finalArray = [];
              // console.log(arr2)
              arr1.forEach((e1)=>arr2.forEach((e2)=>
                {if(e1 === e2.date){
                  finalArray.push({
                   key: e1,
                   val: e2.tran_amount
                  })

                } else {
                 finalArray.push({
                   key: e1,
                   val: 0
                  })
                }
               }
              ))
              return finalArray;
            }

             let objArr = compare(chartLabel,transactions)

             const output = objArr.reduce((accumulator, cur) => {
              let date = cur.key;
              let found = accumulator.find(elem => elem.key === date)
              if (found) found.val += cur.val;
              else accumulator.push(cur);
              return accumulator;
            }, []);
              for (let i=0; i<output.length; i++) {
                period.push(moment(output[i].key).format('MMM YYYY'))
                amount.push(output[i].val.toFixed(2))
              }

              let transactionChartMonthly = {}
              transactionChartMonthly.period = period
              transactionChartMonthly.amount = amount

            yield put(transactionMonthlySuccess(transactionChartMonthly));
          }
          // let object = {}, transactions = [];
          // let period = [], amount = [];
          //
          // for (let i=0; i < transactionFetchs.length; i++) {
          //     let date = transactionFetchs[i].tran_issuedate;
          //     let localDateString = date.substring(0, 7)
          //     if (object[localDateString]) {
          //         object[localDateString].tran_amount += transactionFetchs[i].tran_amount;
          //     } else {
          //         transactionFetchs[i].date = localDateString;
          //         delete transactionFetchs[i].tran_issuedate;
          //         object[localDateString] = transactionFetchs[i];
          //     }
          // }
          //
          // for (var prop in object) {
          //   transactions.push(object[prop]);
          // }
          //
          // transactions.sort(sortOrder('date'));
          // transactions.splice(6)
          //
          // for (let i=0; i<transactions.length; i++) {
          //   period.push(transactions[i].date)
          //   amount.push(transactions[i].tran_amount.toFixed(2))
          // }
          //
          // let transactionChartMonthly = {}
          // transactionChartMonthly.period = period
          // transactionChartMonthly.amount = amount
          //
          // yield put(transactionMonthlySuccess(transactionChartMonthly));

        } else {
          let transactionChartMonthly = {}
          transactionChartMonthly.period = chartLabel
          transactionChartMonthly.amount = []
            yield put(transactionMonthlyFail(transactionChartMonthly));
        }
    } catch (error) {
        yield put(transactionMonthlyFail(error));
    }
}

const transactionMachineTypeFetchAsync = async (queryString) =>
    await API.get('/transaction/chart/machinetyperatio/?'+queryString, {},
    {
      "headers" : auth
    })
        .then(payments => payments)
        .catch(error => error);

function* transactionMachineTypeFetch({ payload }) {
    const queryString = Object.keys(payload.tranMachineType).map(key => key + '=' + payload.tranMachineType[key]).join('&');
    try {
        const transactionMachineTypeFetch = yield call(transactionMachineTypeFetchAsync, queryString);
        if (transactionMachineTypeFetch.data.StatusCode === "0000") {
          let transaction = transactionMachineTypeFetch.data.ResultValues;
          let label = []
          let amount = []
          let transactionChartMachineTypeRatio = {}
          for (let i=0; i<transaction.length; i++) {
            label.push(transaction[i].label)
            amount.push(transaction[i].amount)
          }

          transactionChartMachineTypeRatio.label = label
          transactionChartMachineTypeRatio.amount = amount
            yield put(transactionMachineTypeFetchSuccess(transactionChartMachineTypeRatio));

        } else {
            yield put(transactionMachineTypeFetchFail(transactionFetch.data.Message));
        }
    } catch (error) {
        yield put(transactionFail(error));
    }
}

const transactionComfirmationFetchAsync = async (user, queryString) =>
    await API.get('/transaction/chart/paymentcomfirmation?'+queryString,
    {
      headers : {
        'Content-Type': 'application/json',
        'userid': user.user_id,
        'usertoken': user.user_token,
        'apikey': apikey
      }
    })
        .then(payments => payments)
        .catch(error => error);

function* transactionComfirmationFetch({ payload }) {
    const { userid, usertoken, startdate, enddate } = payload.tranConfirm
    let userData = {}
    let query = {}
    userData.user_id = userid
    userData.user_token = usertoken
    query.startdate = startdate
    query.enddate = enddate
    const queryString = Object.keys(query).map(key => key + '=' + query[key]).join('&');
    try {
        const transactionComfirmationFetch = yield call(transactionComfirmationFetchAsync, userData, queryString);
        if (transactionComfirmationFetch.data.StatusCode === "0000") {
          let result = transactionComfirmationFetch.data.ResultValues[0]

          let ratio = (result.request_success*100)/result.request_all
          let data = isNaN(ratio) ? 0 :ratio
            yield put(transactionComfirmationFetchSuccess(data.toFixed(0)));

        } else {
            yield put(transactionComfirmationFetchFail(transactionFetch.data.Message));
        }
    } catch (error) {
        yield put(transactionFail(error));
    }
}

const transactionByServiceFetchhAsync = async (user, queryString) =>
    await API.get('/transaction/chart/servicetyperaito?'+queryString,
    {
      headers : {
        'Content-Type': 'application/json',
        'userid': user.user_id,
        'usertoken': user.user_token,
        'apikey': apikey
      }
    })
        .then(payments => payments)
        .catch(error => error);

function* transactionByServiceFetch({ payload }) {
    const { userid, usertoken, startdate, enddate } = payload.tranByService
    let userData = {}
    let query = {}
    userData.user_id = userid
    userData.user_token = usertoken
    query.startdate = startdate
    query.enddate = enddate
    const queryString = Object.keys(query).map(key => key + '=' + query[key]).join('&');
    try {
        const transactionByServiceFetch = yield call(transactionByServiceFetchhAsync, userData, queryString);
        if (transactionByServiceFetch.data.StatusCode === "0000") {
            let transaction = transactionByServiceFetch.data.ResultValues;
            let label = []
            let amount = []
            let data = {}
            for (let i=0; i<transaction.length; i++) {
              label.push(transaction[i].service_name)
              amount.push(transaction[i].service_amount)
            }

            data.label = label
            data.amount = amount

            yield put(transactionByServiceFetchSuccess(data));

        } else {
            yield put(transactionByServiceFetchFail(transactionFetch.data.Message));
        }
    } catch (error) {
        yield put(transactionByServiceFetchFail(error));
    }
}

export function* watchTransactionFetch() {
    yield takeEvery(TRANSACTION_FETCH, transactionFetch);
    yield takeEvery(TRANSACTION_MONTHLY_FETCH, transactionMonthlyFetch);
    yield takeEvery(TRANSACTION_MACHINETYPE_FETCH, transactionMachineTypeFetch);
    yield takeEvery(TRANSACTION_SUMMARY_FETCH, transactionSummaryFetch);
    yield takeEvery(TRANSACTION_CONFIRMATION_FETCH, transactionComfirmationFetch);
    yield takeEvery(TRANSACTION_BY_SERVICE_FETCH, transactionByServiceFetch);
}

export default function* rootSaga() {
    yield all([
        fork(watchTransactionFetch),
    ]);
}
